
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 154 154"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"77","cy":"77","r":"76.2","fill":"#00a8e9"}}),_c('path',{attrs:{"d":"M126.2 62.6c-.3-14-11.4-25.3-25.4-25.4-12.9-.1-20.9 10.3-23.8 13.1-2.9-2.8-10.9-13.3-23.8-13.2-14 .1-25.1 11.4-25.4 25.4-.4 20.5 45.5 59.2 49.2 59.1 3.6.2 49.6-38.5 49.2-59z","fill":"#fff"}})])
          )
        }
      }
    